// Customer care sidebar navigation
// - Binds smooth scrolling to sidebar links
// - Manages active state on click and on scroll (via IntersectionObserver)
// - Only runs when the customer care section and nav are present on the page

document.addEventListener('DOMContentLoaded', function () {
  console.log('[Customer Care] Script loaded');
  var sectionEl = document.querySelector('[data-customer-care-section]');
  if (!sectionEl) {
    console.log('[Customer Care] Section not found');
    return;
  }

  var nav = sectionEl.querySelector('[data-customer-care-nav]');
  var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('a[href^="#cc-item-"]')) : [];
  console.log('[Customer Care] Found', links.length, 'nav links');
  if (!links.length) return;

  // Helper: set active state on sidebar item by matching link href
  function setActiveLinkByHref(href) {
    console.log('[Customer Care] setActiveLinkByHref called with href:', href);
    links.forEach(function (l) {
      var item = l.closest('.customer-care__sidebar-item');
      if (item) item.classList.remove('customer-care__sidebar-item--active');
    });

    var activeLink = null;
    links.forEach(function (l) {
      if (l.getAttribute('href') === href) {
        var item = l.closest('.customer-care__sidebar-item');
        if (item) item.classList.add('customer-care__sidebar-item--active');
        activeLink = l;
      }
    });

    // Update image based on active link
    updateActiveImage(href);
  }

  // Store last visible block ID to keep image when section has no image
  var lastVisibleBlockId = null;

  // Initialize lastVisibleBlockId from the first visible image BEFORE defining updateActiveImage
  var sidebarImagesInit = sectionEl.querySelector('[data-customer-care-sidebar-images]');
  console.log('[Customer Care] Sidebar images container found:', !!sidebarImagesInit);
  if (sidebarImagesInit) {
    var firstImage = sidebarImagesInit.querySelector('.customer-care__sidebar-image:not(.customer-care__sidebar-image--hidden)');
    if (firstImage) {
      lastVisibleBlockId = firstImage.getAttribute('data-image-for-block');
      console.log('[Customer Care] Initialized lastVisibleBlockId from visible image:', lastVisibleBlockId);
    } else {
      // If no visible image, get the first image anyway
      var anyImage = sidebarImagesInit.querySelector('.customer-care__sidebar-image');
      if (anyImage) {
        lastVisibleBlockId = anyImage.getAttribute('data-image-for-block');
        console.log('[Customer Care] Initialized lastVisibleBlockId from first image:', lastVisibleBlockId);
      }
    }
    var allImages = sidebarImagesInit.querySelectorAll('.customer-care__sidebar-image');
    console.log('[Customer Care] Total sidebar images found:', allImages.length);
    allImages.forEach(function (img, index) {
      console.log('[Customer Care] Sidebar image', index, 'block ID:', img.getAttribute('data-image-for-block'), 'hidden:', img.classList.contains('customer-care__sidebar-image--hidden'));
    });
  }

  // Helper: update image visibility based on active block
  function updateActiveImage(href) {
    console.log('[Customer Care] updateActiveImage called with href:', href);
    var sidebarImages = sectionEl.querySelector('[data-customer-care-sidebar-images]');

    console.log('[Customer Care] Sidebar images container:', !!sidebarImages);

    if (!sidebarImages) {
      console.log('[Customer Care] No sidebar images container found, returning');
      return;
    }

    // Extract block ID from href (e.g., "#cc-item-rte_Jreg8r" -> "rte_Jreg8r")
    var blockId = null;
    if (href) {
      // Match #cc-item- followed by any characters (block IDs can be like rte_Jreg8r or numeric)
      var match = href.match(/#cc-item-(.+)/);
      if (match) {
        blockId = match[1];
        console.log('[Customer Care] Extracted blockId from href:', blockId);
      } else {
        console.log('[Customer Care] Could not extract blockId from href:', href);
      }
    }

    // Check if there's an image for this block
    var hasImageForBlock = false;
    if (blockId) {
      if (sidebarImages) {
        // Try different selector approaches
        var checkImage = sidebarImages.querySelector('[data-image-for-block="' + blockId + '"]');
        if (!checkImage) {
          // Try finding all images and checking their attributes
          var allSidebarImages = sidebarImages.querySelectorAll('.customer-care__sidebar-image');
          console.log('[Customer Care] Checking', allSidebarImages.length, 'sidebar images for block', blockId);
          for (var i = 0; i < allSidebarImages.length; i++) {
            var imgBlockId = allSidebarImages[i].getAttribute('data-image-for-block');
            console.log('[Customer Care] Sidebar image', i, 'has block ID:', imgBlockId, 'matches:', imgBlockId === blockId);
            if (imgBlockId === blockId) {
              checkImage = allSidebarImages[i];
              break;
            }
          }
        }
        if (checkImage) {
          hasImageForBlock = true;
          lastVisibleBlockId = blockId;
          console.log('[Customer Care] Found image for block', blockId, 'in sidebar');
        }
      }
      if (!hasImageForBlock) {
        console.log('[Customer Care] No image found for block', blockId);
      }
    }

    // Use block ID if it has image, otherwise use last visible block ID
    var targetBlockId = hasImageForBlock ? blockId : lastVisibleBlockId;
    console.log('[Customer Care] Target block ID:', targetBlockId, '(hasImageForBlock:', hasImageForBlock, ', lastVisibleBlockId:', lastVisibleBlockId, ')');

    if (!targetBlockId) {
      console.log('[Customer Care] No target block ID available, returning');
      return; // No target block ID available
    }

    // Hide all sidebar images
    var sidebarImageElements = sidebarImages.querySelectorAll('.customer-care__sidebar-image');
    console.log('[Customer Care] Hiding', sidebarImageElements.length, 'sidebar images');
    sidebarImageElements.forEach(function (imgEl) {
      imgEl.classList.add('customer-care__sidebar-image--hidden');
    });

    // Show image for target block if it exists
    if (targetBlockId) {
      var activeSidebarImage = sidebarImages.querySelector('[data-image-for-block="' + targetBlockId + '"]');
      if (activeSidebarImage) {
        activeSidebarImage.classList.remove('customer-care__sidebar-image--hidden');
        console.log('[Customer Care] Showing sidebar image for block', targetBlockId);
      } else {
        console.log('[Customer Care] Sidebar image for block', targetBlockId, 'not found');
      }
    }
  }

  // Initial state: mark the first nav item as active on page load
  if (links[0]) {
    var firstHref = links[0].getAttribute('href');
    console.log('[Customer Care] Initializing with first link href:', firstHref);
    if (firstHref) {
      setActiveLinkByHref(firstHref);
    } else {
      // If no href, still try to update image from first link
      console.log('[Customer Care] First link has no href, calling updateActiveImage with null');
      updateActiveImage(null);
    }
  }

  // Smooth scroll for sidebar links + immediate active state on click
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();

      // Adjust this offset if there is a fixed header overlapping the content
      var headerOffset = 100;
      var rect = target.getBoundingClientRect();
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var targetY = rect.top + scrollTop - headerOffset;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });

      // Immediately mark clicked link as active and update image
      console.log('[Customer Care] Link clicked, href:', href);
      setActiveLinkByHref(href);
    });
  });

  // Active state on scroll using IntersectionObserver
  // Keeps the sidebar in sync with the currently visible content block.
  var targets = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-customer-care-target]'));
  if (!('IntersectionObserver' in window) || !targets.length) return;

  var linkMap = {};
  links.forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href) return;
    // key is the full href, e.g. '#cc-item-123'
    linkMap[href] = link;
  });

  // Flag: until the user scrolls manually, ignore observer updates
  // This prevents the initial layout/paint from overriding the default active item.
  var hasUserScrolled = false;

  function onFirstScroll() {
    hasUserScrolled = true;
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var observer = new IntersectionObserver(function (entries) {
    // Do not change active link until the user has actually scrolled
    if (!hasUserScrolled) return;

    // Filter entries that are currently intersecting the viewport
    var visible = entries.filter(function (entry) {
      return entry.isIntersecting;
    });

    if (!visible.length) return;

    // Choose the element whose center is closest to the viewport center
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var viewportCenter = viewportHeight / 2;

    var bestEntry = visible.reduce(function (best, entry) {
      var rect = entry.target.getBoundingClientRect();
      var elemCenter = rect.top + rect.height / 2;
      var distance = Math.abs(elemCenter - viewportCenter);

      if (!best || distance < best.distance) {
        return { entry: entry, distance: distance };
      }
      return best;
    }, null);

    if (!bestEntry) return;

    var id = bestEntry.entry.target.getAttribute('id');
    if (!id) return;

    var key = '#' + id;
    if (!linkMap[key]) {
      console.log('[Customer Care] No link found for key:', key);
      return;
    }

    console.log('[Customer Care] IntersectionObserver detected active section:', key);
    setActiveLinkByHref(key);
  }, {
    root: null,
    // Active window for a content block: vertical band around the middle of the viewport.
    // Adjust rootMargin if the threshold should move higher or lower on screen.
    rootMargin: '-35% 0px -65% 0px',
    threshold: 0.0
  });

  targets.forEach(function (target) {
    observer.observe(target);
  });
});